import { Shield, MapPin, Bot } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const TrustSection = () => {
  const stats = [
    { icon: MapPin, number: "Regional", label: "Vertrauensvoller Service" },
    { icon: Shield, number: "Effektiv", label: "Schutz gegen Betrug" },
    { icon: Bot, number: "24/7", label: "KI-Beratung gegen Betrug" },
  ];

  return (
    <section className="py-20 gradient-subtle">
      <div className="container mx-auto px-4">
        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="mx-auto mb-4 w-16 h-16 gradient-trust rounded-full flex items-center justify-center">
                <stat.icon className="w-8 h-8 text-white" />
              </div>
              <div className="text-3xl font-bold text-primary mb-2">{stat.number}</div>
              <div className="text-muted-foreground">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Trust Elements */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <h2 className="text-4xl font-bold mb-4">Vertrauen Sie auf unsere Expertise</h2>
          <p className="text-xl text-muted-foreground mb-8">
            Regionaler Service mit persönlicher Betreuung. Wir schützen Sie vor Online-Betrug.
          </p>
        </div>

        {/* Security Promise */}
        <div className="text-center">
          <Card className="max-w-2xl mx-auto gradient-trust text-white shadow-glow">
            <CardContent className="p-8">
              <Shield className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-2xl font-bold mb-4">Unser Sicherheitsversprechen</h3>
              <p className="text-lg opacity-90">
                Wir bieten professionellen Schutz vor Betrug mit modernster Technologie. Ihre Daten sind bei uns sicher
                verschlüsselt und DSGVO-konform geschützt.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
